import React from 'react';
import {
    ItemsNotAllowedText,
    ExclusionItemsNotAllowedDiv,
    ItemTitle,
    Description,
    ButtonFooter,
    ProductsContainer,
} from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { hideScrolling, resumeScrolling } from 'src/utils/util';
import { useTranslation } from 'react-i18next';

//44
const ExclusionItemsNotAllowed = ({
    onClose,
    productsNotAddedToCart,
    message,
    content,
    isSurgery,
}) => {
    const { t } = useTranslation();
    let isSetMessageFlag = productsNotAddedToCart[0]?.isSet && isSurgery ;
    return (
        <>
            <Popup id={'surgery-notification-exclusionItemsNotAllowed-popup'} landscapeMarginTop={'75px'} title={message ? '' : `${isSetMessageFlag ?t('common.setNotAllowed'):t('common.itemNotAllowed')}`} style={{display:'block'}} hideIcon margin impersonationBackground={'rgba(47, 45, 70, 0.53)'}>
                {/* <Popup title={'Item(s) Not Allowed'} hideIcon margin> */}
                <ExclusionItemsNotAllowedDiv
                    mbHeight={message ? '' : 'auto'}
                    height={message ? '' : 'auto'}
                    width={message ? '' : '500px'}
                >
                    <ItemsNotAllowedText
                        fontFamily={message ? '' : 'AvenirNextWorld Regular'}
                        color={message ? '' : '#000000'}
                        height={message ? 'auto' : 'auto'}
                         style={{  whiteSpace: 'pre-wrap', }}
                    >
                        {' '}
                        {/* The {productsAddedToCart} sets/items will be added to
                        your cart. */}
                        {message ? (
                            message
                        ) : (content ? content :
                            <span style={{ textAlign: 'left', width: '100%' }}>
                                {isSetMessageFlag?t('common.setNotAllowedMessage'):t('common.itemNotAllowedMessage')}
                                <br />
                            </span>
                        )}
                    </ItemsNotAllowedText>

                    {!message? (
                        <div
                            style={{
                                maxHeight: '200px',
                                overflowY: 'scroll',
                                display:'block',
                                marginTop: '15px',
                            }}
                        >
                            {productsNotAddedToCart.map((product, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                    }}
                                >
                                    <ItemTitle
                                        mbFlexBasis={'100%'}
                                        flexBasis={'100%'}
                                        key={index}
                                    >
                                        {`${product?.productCFN ? product.productCFN : product.cfn} - `}
                                        {product?.description?.length
                                            ? product.description[0] +
                                            product.description
                                                .slice(1)
                                                .toLowerCase()
                                            : ''}
                                    </ItemTitle>
                                    {/* <Description mbFlexBasis={'100%'} flexBasis={'100%'}>
                                       {product?.description?.length
                                            ? product.description[0] +
                                              product.description
                                                  .slice(1)
                                                  .toLowerCase()
                                            : ''}
                                    </Description> */}
                                </div>
                            ))}
                        </div>
                    ) : (
                        <ProductsContainer
                            isProductTemplateExclusionItems={true}
                            onPointerMove={resumeScrolling}
                            onTouchMove={resumeScrolling}
                            onTouchEnd={hideScrolling}
                            scrollBarWidth={'5px'}
                            scrollBarBackgroundColor={'#888'}
                            scrollBarBorderRadius={'10px'}
                            scrollbarHeight={'2rem'}
                            scrollBarBackGroundColorOnHover={'#555'}
                            mobileDeviceScrollBarDisplay={'block'}
                            mediumDeviceScrollBarDisplay={'block'}
                        >
                            {productsNotAddedToCart.map((product, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                    }}
                                >
                                    <ItemTitle key={index}>
                                        {product.productCFN}
                                    </ItemTitle>
                                    <Description>
                                        {product?.description?.length
                                            ? product.description[0] +
                                            product.description
                                                .slice(1)
                                                .toLowerCase()
                                            : ''}
                                    </Description>
                                </div>
                            ))}
                        </ProductsContainer>
                    )}
                    {!message && message !== undefined && (
                        <ItemsNotAllowedText
                            fontFamily={'AvenirNextWorld Regular'}
                            color={'#000000'}
                            height={message ? '' : 'auto'}
                        >{
                                content ? '' :

                                    <span style={{ textAlign: 'left', width: '100%', whiteSpace: 'pre-wrap', }}>
                                        {isSurgery ? t('common.setAndItemNotAllowedFooter')
                                            :t('equity.surgery.notifications.contactGuidance')}
                                        
                                        <br />
                                    </span>}
                        </ItemsNotAllowedText>
                    )}
                </ExclusionItemsNotAllowedDiv>
                {!message ? (
                    <ButtonFooter
                        showCancelButton={true}
                        center={true}
                        mbPosition={'relative'}
                    >
                        <Button
                          id={'surgery-notifications-exclusionitemsnotallowed-continue'}
                            show={true}
                            width={'150px'}
                            height={'36px'}
                            variant={ButtonStyles?.primary}
                            //primary={true}
                            margin={'5px'}
                            fontSize={'14.5px'}
                            clicked={onClose}
                        >
                           {t('scheduleSurgery.surgery.notifications.ExclusionItemsNotAllowed.continueButton')}
                        </Button>
                    </ButtonFooter>
                ) : (
                    <ButtonFooter showCancelButton={true} center={true}>
                        <Button
                          id={'surgery-notifications-exclusionitemsnotallowed-continuebutton'}
                            show={true}
                            width={'150px'}
                            height={'36px'}
                            variant={ButtonStyles?.primary}
                            //primary={true}
                            margin={'5px'}
                            fontSize={'14.5px'}
                            clicked={onClose}
                        >
                           {t('scheduleSurgery.surgery.notifications.ExclusionItemsNotAllowed.continueButton')}
                        </Button>
                    </ButtonFooter>
                )}
            </Popup>
        </>
    );
};

export default ExclusionItemsNotAllowed;
